<template>
  <b-overlay :show="loading" rounded="sm">
    <div class="srt-embed-container" :class="{ dark: isDarkMode }">
      <div :id="`srt-embed-root-${currentAgencyId}`"></div>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapState } from "vuex";
import { debounce } from "lodash-es";

export default {
  name: 'SrtEmebed',
  props: {
    showNotification: Boolean
  },
  data() {
    return  {
      initialized: false,
      channels: {},
      categories: {},
      syncIds: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters('user', ['currentToken', 'isDarkMode']),
    ...mapGetters('agency', ['currentAgencyId'])
  },
  created() {
    this.$nextTick(() => {
      if (this.$conveyInstance) {
        this.loading = true;
        if (this.$conveyInstance && this.$conveyInstance.endRadio) {
          this.$conveyInstance.endRadio();
        }
        setTimeout(() => {
          const params = {
            $container: `srt-embed-root-${this.currentAgencyId}`,
            darkMode: true,
            accessToken: this.currentToken,
            onTranscript: debounce((transcript) => {
              const { syncId } = transcript;
              if (!this.syncIds.includes(syncId) && this.showNotification) {
                this.syncIds.push(syncId);
                this.onSrtTranscript(transcript);
              }
            }, 500),
            onReady: (config) => {
              this.onSrtReady(config);
            }
          };
          this.$conveyInstance.radio(params);
          this.initialized = true;
          this.loading = false;
        }, 5000);
      }
    });
  },
  methods: {
    onSrtReady(config) {
      const { channels, categories } = config;
      if (channels) {
        this.channels = { ...channels };
      }
      if (categories) {
        this.categories = { ...categories };
      }
    },
    onSrtTranscript(transcript) {
      const { message } = transcript;
      const { data: transcriptData } = message;
      const { keywords, channelId, transcriptionSegments, transcription } = transcriptData;
      if (keywords && keywords.length > 0 && transcriptionSegments && transcriptionSegments.length > 0) {
        const notificationTitle = this.channels[channelId] ? this.channels[channelId].name : '';
        const notificationContent = transcriptionSegments
          .sort((a, b) => a.listRank - b.listRank)
          .map(segment => {
            const { useCategory, categoryId, text } = segment;
            if (useCategory && categoryId) {
              const category = { ...this.categories[categoryId] };
              const { highlight } = category;
              const { backgroundColor, fontColor } = highlight;
              const { r, g, b, a } = backgroundColor;
              const { r: fr, g: fg, b: fb, a: fa } = fontColor;
              return `<strong style="background-color: rgba(${r}, ${g}, ${b}, ${a}); color: rgba(${fr}, ${fg}, ${fb}, ${fa});">${text}</strong>`
            } else {
              return text;
            }
          })
          .join(' ');
        this.$srtToastr('info', notificationContent, notificationTitle);
      } else {
        // const notificationTitle = this.channels[channelId] ? this.channels[channelId].name : '';
        // this.$srtToastr('info', transcription, notificationTitle);
      }
    }
  },
  beforeDestroy() {
    if (this.$conveyInstance && this.$conveyInstance.endRadio) {
      this.$conveyInstance.endRadio();
    }
  },
};
</script>

<style lang="scss">
</style>